import React from "react";
import { motion } from "framer-motion";
import { Shield, Lock, EyeOff, FileHeart, Users, Scale } from "lucide-react";
import SEO from "../components/SEO";
import { useLanguage } from "../context/LanguageContext";

export default function Ethics() {
    const { t } = useLanguage();

    return (
        <div className="min-h-screen bg-spiritual-white dark:bg-gray-950 text-gray-800 dark:text-gray-100 font-body">
            <SEO 
              title={t("ethics_title")} 
              description={t("ethics_tagline")} 
              url="/ethics" 
            />
            <main className="max-w-4xl mx-auto px-6 py-20 md:py-32 space-y-12">

                <header className="text-center space-y-6">
                    <div className="flex justify-center text-brand-blue mb-4">
                        <Shield className="w-12 h-12 opacity-80" />
                    </div>
                    <h1 className="text-4xl md:text-5xl font-display font-medium">{t("ethics_title")}</h1>
                    <p className="text-xl text-gray-500 dark:text-gray-400 font-light">
                        {t("ethics_tagline")}
                    </p>
                </header>

                <div className="grid md:grid-cols-2 gap-8 mt-12">

                    <Card
                        icon={Lock}
                        title={t("ethics_data_title")}
                        desc={t("ethics_data_desc")}
                    />

                    <Card
                        icon={EyeOff}
                        title={t("ethics_anon_title")}
                        desc={t("ethics_anon_desc")}
                    />

                    <Card
                        icon={Shield}
                        title={t("ethics_abuse_title")}
                        desc={t("ethics_abuse_desc")}
                    />

                    <Card
                        icon={Users}
                        title={t("ethics_human_title")}
                        desc={t("ethics_human_desc")}
                    />

                    <Card
                        icon={Scale}
                        title={t("ethics_integrity_title")}
                        desc={t("ethics_integrity_desc")}
                        className="md:col-span-2"
                    />

                </div>

                <section className="bg-blue-50 dark:bg-gray-900 p-8 rounded-2xl mt-16 border border-blue-100 dark:border-gray-800">
                    <h3 className="text-xl font-semibold mb-4 text-brand-blue">{t("ethics_crisis_title")}</h3>
                    <p className="leading-relaxed text-gray-700 dark:text-gray-300">
                        {t("ethics_crisis_desc")}
                    </p>
                </section>

            </main>
        </div>
    );
}

function Card({ icon: Icon, title, desc, className = "" }) {
    return (
        <div className={`p-8 bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-700 ${className}`}>
            <div className="w-10 h-10 bg-brand-blue/10 dark:bg-brand-blue/20 text-brand-blue rounded-lg flex items-center justify-center mb-4">
                <Icon className="w-5 h-5" />
            </div>
            <h3 className="text-lg font-semibold mb-3">{title}</h3>
            <p className="text-gray-600 dark:text-gray-400 leading-relaxed text-sm">
                {desc}
            </p>
        </div>
    )
}
